import React from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "../../store";

interface AuthGuardProps {
  children: React.ReactNode;
  redirectTo?: string;
  requireAuth?: boolean;
}

const AuthGuard: React.FC<AuthGuardProps> = ({
  children,
  redirectTo = "/",
  requireAuth = true,
}) => {
  const { accessToken } = useAppSelector((state) => state.auth);
  const isAuthenticated = !!accessToken;

  if (requireAuth && !isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!requireAuth && isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default AuthGuard;

